<template>
  <div class="animated fadeIn">
    <Forms ref="frmSearch"
           :title="$lang.EmployeeBoard.AddBoard.TitleForm"
           :showHelp="false"
           :showClearButton="true"
           :showSaveButton="true"
           :showBackButton="true"
           v-on:Clear="onClear"
           v-on:Back="onBack"
           v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label for="txtPedido"><small v-show="form.pedido.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddBoard.LabelOrder}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtPedido"
                          ref="pedidoComp"
                          :placeholder="$lang.EmployeeBoard.AddBoard.PlaceholderOrder"
                          :autofocus="true"
                          v-model="form.pedido.value"
                          :maxlength="form.pedido.maxlength"
                          :required="form.pedido.required"
                          :state="form.pedido.state" />
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsure"><small v-show="form.obraRHID.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddBoard.LabelConstructions}}:</label>
          <autocomplete-z ref="obraRHTypeahead"
                          :placeholder="$lang.EmployeeBoard.AddBoard.PlaceholderConstructions"
                          iconClass="fas fa-hard-hat"
                          :serializer="(obra) => obra.codigo + ' - ' + obra.nome"
                          :debounceLength="2"
                          :formField="form.obraRHID"
                          v-on:search="onSearchObraRH"
                          v-on:changeCode="onChangeCodeObraRH" />
        </div>
        <div class="col-md-4">
          <label for="txtInsured"><small v-show="form.responsavelID.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddBoard.LabelResponsible}}:</label>
          <autocomplete-z ref="responsavelTypeahead"
                          :placeholder="$lang.EmployeeBoard.AddBoard.PlaceholderResponsible"
                          iconClass="fas fa-users"
                          :serializer="(responsavel) => responsavel.codigo + ' - ' + responsavel.nome"
                          :debounceLength="3"
                          :formField="form.responsavelID"
                          v-on:search="onSearchResponsavel"
                          v-on:changeCode="onChangeCodeResponsavel" />
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-4">
          <label for="cbxInsure"><small v-show="form.secaoRHID.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddBoard.LabelRegional}}:</label>
          <div class="input-group">
            <b-form-input type="number"
                          class="col-2 text-upper"
                          style="height: calc(2.09375rem + 2px); text-align: center"
                          :placeholder="$lang.Common.PlaceholderCode"
                          v-model="form.secaoRH.value"
                          :maxlength="form.secaoRH.maxlength"
                          :state="form.secaoRH.state"
                          :min="1"
                          @focus="onClearSection"
                          @change="onChangeCodeSection" />&nbsp;
            <b-form-select v-model="form.secaoRHID.value"
                           :options="form.secaoRHID.options"
                           :required="form.secaoRHID.required"
                           :state="form.secaoRHID.state">
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtCodePeople"><small v-show="form.inicioObra.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddBoard.LabelBeginConstructions}}:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtInicioObra"
                          ref="inicioObraComp"
                          v-model="form.inicioObra.value"
                          :required="form.inicioObra.required"
                          :state="form.inicioObra.state" />
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtCodePeople"><small v-show="form.terminoObra.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddBoard.LabelEndConstructions}}:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtTerminoObra"
                          ref="terminoObraComp"
                          v-model="form.terminoObra.value"
                          :required="form.terminoObra.required"
                          :state="form.terminoObra.state" />
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsure"> {{$lang.EmployeeBoard.AddBoard.LabelClient}}:</label>
          <autocomplete-z ref="clienteRHTypeahead"
                          :placeholder="$lang.EmployeeBoard.AddBoard.PlaceholderClient"
                          iconClass="fas fa-user-tie"
                          :serializer="(cli) => cli.codigo + ' - ' + cli.nome"
                          :debounceLength="3"
                          :formField="form.clienteRHID"
                          v-on:search="onSearchClienteRH"
                          v-on:changeCode="onChangeCodeClienteRH" />
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-4">
          <label for="txtInsured"> {{$lang.EmployeeBoard.AddBoard.LabelTeam}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-user"></i></span>
            <b-form-input type="text"
                          :placeholder="$lang.EmployeeBoard.AddBoard.PlaceholderTeam"
                          v-model="form.equipe.value"
                          :maxlength="form.equipe.maxlength"
                          :state="form.equipe.state" />
          </div>
        </div>
        <div class="col-md-2">
          <label for="cbxInsure"> {{$lang.Common.LabelCountry}}:</label>
          <div class="input-group">
            <select class="mb-3 form-control custom-select" disabled>
              <option :value="$lang.Common.GuidCountry" selected>
                {{$lang.Common.NameCountry}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <label for="cbxInsure"> {{$lang.Common.LabelState}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.estadoID.value"
                           :options="form.estadoID.options"
                           :state="form.estadoID.state"
                           :disabled="form.estadoID.disabled"
                           @change="onChangeState"
                           class="mb-3"
                           name="cbxState">
              <template slot="first">
                <option :value="null" disabled>
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsure"> {{$lang.Common.LabelCity}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.cidadeID.value"
                           :options="form.cidadeID.options"
                           :state="form.cidadeID.state"
                           class="mb-3"
                           name="cbxCity">
              <template slot="first">
                <option :value="null" disabled>
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtDescription"> {{$lang.EmployeeBoard.AddBoard.LabelObservation}}:</label>
          <b-form-textarea id="txtDescription"
                           name="txtDescription"
                           v-model="form.observacao.value"
                           :placeholder="$lang.EmployeeBoard.AddBoard.PlaceholderObservation"
                           :rows="form.observacao.rows"
                           :maxlength="form.observacao.maxlength"
                           :noResize="form.observacao.noResize" />
          <small class="small-help"><i class="fa fa-info-circle"></i><span v-html="FieldSizeTip"></span>.</small>
        </div>
      </div>
    </Forms>
  </div>
</template>

<script>
import AddBoard from './addboard.js'
export default AddBoard
</script>

<style scoped>
.custom-group-addon {
  padding: 0.4rem 1rem;
  display: block;
  position: absolute;
  z-index: 9;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/employeeboard/board/components/addboard/addboard.vue